import AxiosInstance from '../config/AxiosInstance';

export interface DashboardHourPoint {
  hour: number;
  revenue: number;
  txnCount: number;
}

export interface DashboardOverview {
  date: string;
  live: {
    revenue: number;
    txnCount: number;
    covers: number;
    refunds: number;
    refundCount: number;
    discounts: number;
    voids: number;
    cash: { total: number; hasCashTender: boolean };
    hourly: DashboardHourPoint[];
    topItems: {
      productId: string;
      productName: string;
      quantity: number;
      revenue: number;
    }[];
    now: {
      tillsOnline: number;
      tillsTotal: number;
      openSessions: number;
      pendingOrders: number;
    };
  };
  context: {
    sameWeekdayLastWeek: { date: string; revenue: number; txnCount: number };
    typicalHourly: DashboardHourPoint[];
    weekToDate: { from: string; revenue: number; txnCount: number };
  };
}

const getDashboardOverview = async (locationId?: string) =>
  AxiosInstance.get('/api/inventory/dashboard/overview', {
    params: locationId ? { locationId } : {},
  });

export { getDashboardOverview };
